import {persistReducer, persistStore} from "redux-persist";
import {encryptTransform} from "redux-persist-transform-encrypt";
import storage from 'redux-persist/lib/storage';
import {combineReducers} from "redux";
import userReducer from "./reducers/userReducer";
import appReducer from "./reducers/appReducer";
import thunkMiddleware from 'redux-thunk';
import {initMiddleware} from "../middlewares/initMiddleware";
import {configureStore} from "@reduxjs/toolkit";

const userPersistConfig = {
	key: 'user',
	storage: storage,
	keyPrefix: 'velure-bo-'
};

const rootReducer = combineReducers({
	user: persistReducer(userPersistConfig, userReducer),
	app: appReducer,
});

const middleware = [thunkMiddleware, initMiddleware];

const store = configureStore({
	reducer: rootReducer,
	middleware,
});

const persistor = persistStore(store);

export { store, persistor };
